import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { checkRedirectStatus } from "../Redux/actions/userActions";

const CountryCheck = ({ pageTo, history, country }) => {
  const [timezone, setTimezone] = useState("");
  const [redirectStatusEU, setRedirectStatusEU] = useState(false);
  const [redirectStatusAUS, setRedirectStatusAUS] = useState(false);
  const [URL, setURL] = useState("/");
  const [countryParam, setCountryParam] = useState("");

  // Redux dispatch
  const dispatch = useDispatch();
  // Grab redux state
  const redirectStatusDetail = useSelector((state) => state.redirectStatus);
  const { status } = redirectStatusDetail;
  // Checks to see if timezone contains "Europe"
  const checkEuropeTimezone = (tz) => {
    if (tz.match(/Europe/g) !== null) {
      setRedirectStatusEU(true);
    }
  };
  // Checks to see if timezone contains "Australia"
  const checkAusTimezone = (tz) => {
    if (tz.match(/Australia/g) !== null) {
      setRedirectStatusAUS(true);
    }
  };

  useEffect(() => {
    // sets timezone value
    setTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone);
    // grabs the url redirect from component
    if (pageTo) {
      setURL(pageTo);
    }
    // country param set on component page
    if (country) {
      setCountryParam(country);
    }
    // init timezone functions
    checkEuropeTimezone(timezone);
    checkAusTimezone(timezone);
  }, [setTimezone, timezone, setURL, pageTo, country]);

  // status is used here to incase someone from the uk wants to see US pages
  if (redirectStatusEU && countryParam !== "uk" && !status) {
    if (
      window.confirm(
        "Visiting from the UK or Europe? Would you like to be redirected to Workforce.com | UK?"
      )
    ) {
      setCountryParam("uk");
      history.push(URL);
    } else {
      dispatch(checkRedirectStatus());
    }
  }
  // status is used here to incase someone from the AUS wants to see US pages
  if (redirectStatusAUS && !status) {
    if (window.confirm("Visiting from Australia?")) {
      window.location.href = "https://www.tanda.co/";
    } else {
      dispatch(checkRedirectStatus());
    }
  }

  return <div></div>;
};

export default CountryCheck;
